import type { IController, IScope } from "angular";
import type { IFeatureFlagService } from "../../../Services/FeatureFlag/IFeatureFlagService";

export class FeatureSwitcherComponentController implements IController {
    public static $inject = ["$scope", "irFeatureFlagService"];

    public feature: string;

    public reverse = false;

    public showFeature = false;

    constructor(private readonly scope: IScope, private readonly featureFlagService: IFeatureFlagService) {}

    public $onInit() {
        const flag = this.featureFlagService.getFlag(this.feature);

        this.showFeature = this.reverse ? !flag : flag;

        this.featureFlagService.flagsObservable().subscribe((flags) => {
            this.showFeature = this.reverse ? !flags[this.feature] : flags[this.feature];

            this.scope.$applyAsync();
        });
    }
}
